<div class="inline-error">
  <mat-icon class="error-icon" [svgIcon]="'error'"></mat-icon>
  <div class="inline-error-text"><ng-content/></div>
</div>
